export const AUTOSAVE_DELAY = 2000;

export const PAGE_TITLE = "Nirva";

export const PAGE_TEXT =
  "Welcome to Nirva—Beautiful thinking. Peaceful living. This is your practitioner hub for the Nirva Practitioner Program, powered by Interpersonal Hypnotherapy. Here you'll find your onboarding steps, required resources, and approved tools to support a secure, consistent, client-centered experience. Complete your profile, confirm your setup, and follow our standards as you begin serving clients through Nirva.";

export const SIGN_UP_CARD = {
  id: 1,
  title: "Sign Up for Nirva Practitioner",
  text: "Join the Nirva Practitioner Program",
  size: 6,
  height: "60px",
};

export const SECTION_TITLES = {
  LEARN_MORE: "Learn More",
  PRACTITIONER_RESOURCES: "Practitioner Resources",
  ONBOARDING: "Onboarding Items",
  SESSION_RESOURCES: "Session Resources",
  SOPS_POLICIES: "SOPs and Policies",
};

export const SNACKBAR_MESSAGES = {
  EDIT_SUBMITTED: "Edit submitted. It will take effect once approved.",
  SUBMISSION_RECEIVED:
    "Your submission has been received. You will appear in the database once approved.",
};

export const FOOTER_TEXT =
  "Let's continue to grow together, expand your horizons, and contribute to the transformational power of Interpersonal Hypnotherapy!";
